import { render, staticRenderFns } from "./QQGroupListPage.vue?vue&type=template&id=cbf990d8"
import script from "./QQGroupListPage.vue?vue&type=script&lang=js"
export * from "./QQGroupListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports